import { useEffect, useState } from "react";
import dynamic from "next/dynamic";

import getPromotedStrains from "api/requests/getPromotedStrains";
import { Action, Category } from "constants/events";
import { PromotedStrain } from "custom-types/Directus";
import { useEventTracker } from "hooks/useEventTracker";
import useFilters from "hooks/useFilters";

const PromotedStrainCarousel = dynamic(
  () => import("components/StrainCarousel"),
);

const ShopPromotedStrainsCarousel: React.FC = () => {
  const { addFilter } = useFilters();
  const { publishEvent } = useEventTracker();

  const [strains, setStrains] = useState<PromotedStrain[]>();

  useEffect(() => {
    getPromotedStrains().then((strains) => setStrains(strains));
  }, []);

  if (strains === undefined || strains.length === 0) {
    return null;
  }

  return (
    <PromotedStrainCarousel
      promotedStrains={strains}
      className="lg:mb-xl"
      onClick={(strain) => {
        addFilter({
          strain_name: strain.strain_name,
        });

        publishEvent({
          action: Action.click,
          category: Category.dealsOnTopStrains,
          label: `strain hub quick access - ${strain.strain_name}`,
        });
      }}
    />
  );
};

export default ShopPromotedStrainsCarousel;
